<template>
    <div v-if="show">
        <h2 class="title is-2 section-header">
            Set IsReleaseReady=true for a complete scope
        </h2>
        <p class="block">
            Running this command will ensure that <code>IsReleaseReady</code> is set to <code>true</code> for all
            sets that is scoped by the specified scope. It will <i>not</i> run any release or publishing of codes.
        </p>
        <div class="block">
            <b-field label="Scope type">
                <b-input v-model="scopeType" />
            </b-field>
            <b-field label="Scope name">
                <b-input v-model="scope" />
            </b-field>
            <b-field>
                <b-switch v-model="dryRun">
                    Dry run (rollback transaction)
                </b-switch>
            </b-field>
        </div>
        <div class="buttons">
            <b-button
                type="is-primary"
                :disabled="!enabled"
                @click="run()">
                Run
            </b-button>
            <b-button
                :disabled="!enabled"
                @click="cancelCommand()">
                Cancel
            </b-button>
        </div>
    </div>
</template>

<script>
    import runMixin from './RunMixin.js';

    export default {
        mixins: [runMixin],
        data() {
            return {
                scopeType: 'Facility', // Sensible default
                scope: '',
                dryRun: true
            };
        },
        methods: {
            async run() {
                await this.submitCommand([
                    'set-release-ready-scope',
                    this.scopeType,
                    this.scope,
                    this.dryRun ? 'dry-run' : ''
                ]);
            }
        }
    };
</script>
